export const createAnswerEntry = ({
  step,
  questionIndex,
  text = null,
  photoUrl = null,
  extractedValue = null,
  isValid = true,
  attempt = 1,
  value = null,
  meta = {},
}) => {
  return {
    stepId: step.id,
    saveKey: step.saveKey || step.id,
    questionIndex,
    text,
    photoUrl,
    extractedValue,
    isValid,
    attempt,
    value,
    ...meta,
  }
}

export const createDerivedAnswerEntry = ({
  stepId,
  value,
  extra = {},
}) => {
  return {
    stepId,
    saveKey: stepId,
    questionIndex: -1,
    text: typeof value === 'string' ? value : null,
    extractedValue: value,
    value,
    isValid: true,
    attempt: 1,
    ...extra,
  }
}

export const upsertAnswerEntry = ({
  answers,
  entry,
}) => {
  const answersWithoutCurrentStep = answers.filter(
    (answer) => answer.stepId !== entry.stepId,
  )

  return [...answersWithoutCurrentStep, entry]
}